import React from 'react'
import { formatDate } from '../helper/formatDate'
import { Link } from 'react-router-dom'
import { useTranslate } from './TranslationText';
import { formateUAEName } from '../helper/formateUAEName';
import PillBtn from './PillBtn';
import { formatDateTimeToString } from '../helper/formatDateTimeToString';


export default function HorseCard({ item, i, showDownloadPassport, isArabicClass, isFilterSection, isProfilePage = false }) {
    const { translate } = useTranslate();
    const BaseBACKENDURL = process.env.REACT_APP_BACKEND_API;

    const langauge = localStorage.getItem('eahsLang') ?? 'en';
    return (
        <div
            key={i}
            className={isArabicClass ? `${isFilterSection ? 'col-xl-4 col-lg-6' : `col-xl-${!!isProfilePage ? '4' : '3'} col-lg-${!!isProfilePage ? '4' : '6'}`} col-md-12 col-sm-12 col-12  mb-main rtl` : "col-lg-3 col-md-6 col-sm-12 mb-main rtl"}
        >
            <div
                className='hourseCardClass bg-white p-main p-3 d-flex flex-column'

            >
                <div className='horseCardTitle mb-1'
                >
                    {item.name}
                </div>
                <div
                    className='horseCardDescription fw-bold '
                >
                    {translate("web.regno", "Regno")}: {item.registerNumber}
                </div>
                <div className='mt-auto'>
                    <div className='mainSpacer my-2' />
                </div>
                <div className="row ">
                    <div
                        className="col-md-6 col-sm-6 mb-sm-0 mb-2"

                    >
                        <div className='horseCardDescription fw-bold'
                        >
                            <i className='fa fa-globe-americas C89C66 me-1' />{translate("web.origin", "origin")}
                        </div>

                        <div
                            className='horseCardDescription'
                        >
                            {formateUAEName(item.origin)}
                        </div>
                    </div>

                    <div
                        className="col-md-6 col-sm-6"
                    >
                        <div
                            className='horseCardDescription fw-bold'

                        >
                            <i className='fa fa-calendar C89C66 me-1' />{translate("web.birthDate", "Birthdate")}
                        </div>

                        <div
                            className='horseCardDescription'

                        >
                            {item?.birthDateObject ? formatDateTimeToString(item?.birthDateObject) : <>&nbsp;</>}
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className='mainSpacer mt-2 mb-main ' />
                    </div>

                    <div className='col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 ms-auto'>
                        <PillBtn isNoPadding={true} isNoMargin={true} isRed={true} text={translate("web.viewDetails", "View Details")} routeName={`/horseDetails?horseId=${item.id}`} />
                    </div>
                    {!!showDownloadPassport && (
                        <Link
                            className="btn btn-secondary position-absolute border-15 fw-bold d-block text-center w-unset "
                            to={`${BaseBACKENDURL}/OwnerProfile/HorsePassport?id=${item.id}`}
                            target="_blank"
                            style={ langauge=='en'? {top:20 , right:20,fontSize:13}:{top:20 , left:20,fontSize:13}}
                        >
                          <i className=" fa-solid fa-download fw-bold text-white w-unset"></i>  {translate('web.ePassport')} 
                        </Link>
                    )}
                </div>

            </div>
        </div>
    )
}
